import * as React from 'react';


type Props = {
  className?: string;
  fill?: string;
  sizePx: number;
};


/**
 * DownloadIcon: a component that renders a downward-pointing arrow icon with a thick underline below, typically used to
 * denote download functions in the app.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const DownloadIcon: React.FC<Props> = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height={props.sizePx}
    viewBox='0 0 24 24'
    width={props.sizePx}
    className={props.className}
  >
    <path d='M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' fill={props.fill} />
  </svg>
);

export default DownloadIcon;
